import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Pricing from './pages/Pricing';
import AWSAccounts from './pages/AWSAccounts';
import Security from './pages/Security';
import CostOptimization from './pages/CostOptimization';
import CostOpportunities from './pages/CostOpportunities';
import ResourceBreakdown from './pages/ResourceBreakdown';
import Inventory from './pages/Inventory';
import Compliance from './pages/Compliance';
import Support from './pages/Support';
import RegulatoryBot from './pages/RegulatoryBot';
import AICloudAssistant from './pages/AICloudAssistant';
import ControlPlaneAdmin from './pages/ControlPlaneAdmin';

import { LayoutProvider } from './contexts/LayoutContext';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) return <Navigate to="/login" />;
  if (user.role !== 'admin') return <Navigate to="/dashboard" />;
  return children;
}

function App() {
  return (
    <CustomThemeProvider>
      <CssBaseline />
      <AuthProvider>
        <NotificationProvider>
          <SnackbarProvider maxSnack={3}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <LayoutProvider>
                    <Layout />
                  </LayoutProvider>
                </ProtectedRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="aws-accounts" element={<AWSAccounts />} />
                <Route path="security" element={<Security />} />
                <Route path="cost-optimization" element={<CostOptimization />} />
                <Route path="cost-opportunities" element={<CostOpportunities />} />
                <Route path="resource-breakdown" element={<ResourceBreakdown />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="compliance" element={<Compliance />} />
                <Route path="regulatory-bot" element={<RegulatoryBot />} />
                <Route path="ai-assistant" element={<AICloudAssistant />} />
                <Route path="control-plane-admin" element={<AdminRoute><ControlPlaneAdmin /></AdminRoute>} />
                <Route path="support" element={<Support />} />
              </Route>
            </Routes>
          </SnackbarProvider>
        </NotificationProvider>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;